import { IMeshColumnData, IWidgetData } from "@pageBuilder/typings";
import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { RendererFactory } from "src/shared/renderer-factory";
import { ElementUtil } from "src/utils/element-util";
import { MeshColumnRenderer } from "../mesh-column-renderer";
import { CascadeRendererFactory } from "src/shared/cascade-renderer-factory";
import { IRenderingCommonContext } from "@commonRendering/types";

export class MeshColumnCascadeRenderer extends CascadeRendererBase<IMeshColumnData> {

    protected readonly renderer: MeshColumnRenderer;

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.renderer = new MeshColumnRenderer();
    }

    public override createByCascade(data: IMeshColumnData): HTMLElement {
        const columnElement = this.renderer.createNew();
        this.renderer.render(columnElement, data);

        data.widgets?.forEach(widgetData => {
            this.createWidgetToColumnByCascade(columnElement, widgetData);
        });

        return columnElement;
    }

    private createWidgetToColumnByCascade(columnElement: HTMLElement, widgetData: IWidgetData): HTMLElement {
        let widgetElement: HTMLElement;

        if (ElementUtil.isWidgetContainer(widgetData.type)) {
            const widgetRenderer = CascadeRendererFactory.create(widgetData.type, this.renderingCommonContext);
            widgetElement = widgetRenderer.createByCascade(widgetData);
        } else {
            const widgetRenderer = RendererFactory.create(widgetData.type, this.renderingCommonContext);
            widgetElement = widgetRenderer.createNew();
            widgetRenderer.render(widgetElement, widgetData);
        }

        columnElement?.append(widgetElement);
        return widgetElement;
    }

    public override getDataByCascade(element: HTMLElement): IMeshColumnData {
        const columnData = this.renderer.getData(element);

        const columnElementWidgets = element.querySelectorAll<HTMLElement>(`:scope > [data-widget]`);

        columnData.widgets = [];

        if (!columnElementWidgets) {
            columnData.isEmpty = true;
        }

        columnElementWidgets?.forEach(widgetElement => {
            const widgetData = this.getWidgetDataByCascade(widgetElement);
            columnData.widgets?.push(widgetData);
        });

        return columnData;
    }

    private getWidgetDataByCascade(widgetElement: HTMLElement): IWidgetData {
        const type = ElementUtil.resolveElementType(widgetElement);

        let widgetData: IWidgetData;

        if (ElementUtil.isWidgetContainer(type)) {
            const widgetRenderer = CascadeRendererFactory.create(type, this.renderingCommonContext);
            widgetData = widgetRenderer.getDataByCascade(widgetElement) as IWidgetData;
        } else {
            const widgetRenderer = RendererFactory.create(type, this.renderingCommonContext);

            widgetData = widgetRenderer.getData(widgetElement) as IWidgetData;
        }

        return widgetData;
    }

}
